(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection"]) return;
  try {
    
  document.getElementById('sort-select')?.addEventListener('change', function () {
    document.getElementById('sort-form').submit();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    const burger = document.querySelector('.site-header__burger');
    const mobileNav = document.getElementById('mobile-nav');
    if (!burger || !mobileNav) return;

    burger.addEventListener('click', () => {
      const isOpen = burger.getAttribute('aria-expanded') === 'true';
      burger.setAttribute('aria-expanded', String(!isOpen));
      mobileNav.hidden = isOpen;
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !mobileNav.hidden) {
        mobileNav.hidden = true;
        burger.setAttribute('aria-expanded', 'false');
        burger.focus();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-press-band"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var lightbox   = document.getElementById('pressLightbox');
    var lbImg      = lightbox.querySelector('.press-lightbox__img');
    var lbClose    = lightbox.querySelector('.press-lightbox__close');
    var lbBackdrop = lightbox.querySelector('.press-lightbox__backdrop');
    var lbPrev     = lightbox.querySelector('.press-lightbox__arrow--prev');
    var lbNext     = lightbox.querySelector('.press-lightbox__arrow--next');

    var images = [];
    var current = 0;

    document.querySelectorAll('.home-press__img-btn').forEach(function (btn) {
      images.push({ src: btn.dataset.src, alt: btn.dataset.alt || '' });
    });

    function show(index) {
      current = index;
      lbImg.src = images[current].src;
      lbImg.alt = images[current].alt;
      lbPrev.hidden = current === 0;
      lbNext.hidden = current === images.length - 1;
    }

    function open(index) {
      show(index);
      lightbox.hidden = false;
      document.body.style.overflow = 'hidden';
    }

    function close() {
      lightbox.hidden = true;
      lbImg.src = '';
      document.body.style.overflow = '';
    }

    document.querySelectorAll('.home-press__img-btn').forEach(function (btn, i) {
      btn.addEventListener('click', function () { open(i); });
    });

    lbPrev.addEventListener('click', function () { if (current > 0) show(current - 1); });
    lbNext.addEventListener('click', function () { if (current < images.length - 1) show(current + 1); });
    lbClose.addEventListener('click', close);
    lbBackdrop.addEventListener('click', close);

    document.addEventListener('keydown', function (e) {
      if (lightbox.hidden) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowLeft' && current > 0) show(current - 1);
      if (e.key === 'ArrowRight' && current < images.length - 1) show(current + 1);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-about-contact"]) return;
  try {
    
  (function () {
    const radios   = document.querySelectorAll('.about-contact__type-radio');
    const commFields = document.querySelectorAll('.about-contact__field--commission');
    const tradeFields = document.querySelectorAll('.about-contact__field--trade');

    function update(type) {
      commFields.forEach((el)  => { el.hidden = type !== 'commission'; });
      tradeFields.forEach((el) => { el.hidden = type !== 'trade-designer'; });
    }

    radios.forEach((r) => r.addEventListener('change', () => { if (r.checked) update(r.dataset.type); }));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-contact"]) return;
  try {
    
  (function () {
    const radios           = document.querySelectorAll('.contact-page__type-radio');
    const commissionFields = document.querySelectorAll('.contact-page__field--commission');
    const tradeFields      = document.querySelectorAll('.contact-page__field--trade');
    const showFields       = document.querySelectorAll('.contact-page__field--show');

    function updateFields(type) {
      commissionFields.forEach((el) => { el.hidden = type !== 'commission'; });
      tradeFields.forEach((el)      => { el.hidden = type !== 'trade-designer'; });

      const isShow = type === 'art-fair-or-show';
      showFields.forEach((el) => {
        el.hidden = !isShow;
        const input = el.querySelector('input');
        if (input) input.required = isShow;
      });
    }

    radios.forEach((radio) => {
      radio.addEventListener('change', () => {
        if (radio.checked) updateFields(radio.dataset.type);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-portfolio-clients"]) return;
  try {
    
  (function () {
    const lightbox = document.getElementById('portclient-lightbox');
    const img      = document.getElementById('portclient-lb-img');
    const cap      = document.getElementById('portclient-lb-cap');
    const closeBtn = document.getElementById('portclient-lb-close');

    if (!lightbox) return;

    document.querySelectorAll('.portclient__thumb').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        img.src = thumb.dataset.src;
        img.alt = thumb.dataset.alt || '';
        cap.textContent = thumb.dataset.alt || '';
        lightbox.showModal();
      });
    });

    closeBtn.addEventListener('click', () => lightbox.close());

    lightbox.addEventListener('click', (e) => {
      if (e.target === lightbox) lightbox.close();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    const mainImg = document.getElementById('product-gallery-main-img');
    const thumbs  = document.querySelectorAll('.product-gallery__thumb');

    if (!mainImg || !thumbs.length) return;

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const src = thumb.dataset.fullSrc;
        const alt = thumb.dataset.fullAlt;

        mainImg.style.opacity = '0';
        setTimeout(() => {
          mainImg.src    = src;
          mainImg.alt    = alt;
          mainImg.style.opacity = '1';
        }, 180);

        thumbs.forEach((t) => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
